let angular = require('angular');
module.exports.MixpanelEventsListener = ['config', '$rootScope', function MixpanelEventsListener(config, $rootScope) {
    return {
        USER_LOGIN: 'MIXPANEL_TRACK_USER_LOGIN',
        SEARCH_DRILL_DOWN: 'MIXPANEL_TRACK_SEARCH_DRILL_DOWN',
        SEARCH: 'MIXPANEL_TRACK_SEARCH',
        USER_REGISTER: 'MIXPANEL_TRACK_USER_REGISTER',
        MEDIA_DOWNLOAD: 'MEDIA_DOWNLOAD',
        MIXPANEL_PLAYLIST_ADD: 'MIXPANEL_PLAYLIST_ADD',
        DISPLAY_SIMILAR_TRACKS: 'MIXPANEL_DISPLAY_SIMILAR_TRACKS',
        THEMED_PLAYLIST: 'MIXPANEL_THEMED_PLAYLIST',
        ALBUM_CLICK: 'MIXPANEL_ALBUM_CLICK',

        track: function() {
            $rootScope.$on(this.USER_LOGIN, (event, data) => {
                mixpanel.track('User Login', data);
            });

            $rootScope.$on(this.SEARCH_DRILL_DOWN, (event, data) => {
                mixpanel.track('Search Drill Down', data);
            });

            $rootScope.$on(this.SEARCH, (event, data) => {
                mixpanel.track('Search', data);
            });

            $rootScope.$on(this.USER_REGISTER, (event, data) => {
                mixpanel.track('User Register', data);
            });

            $rootScope.$on(this.MEDIA_DOWNLOAD, (event, subjects, params, context) => {
                subjects.map(function (subject) {
                    mixpanel.track('Media Download', {
                        filename: params.filename,
                        labelName: subject.album.label.name,
                        labelCode: subject.album.label.code,
                        labelGroupName: subject.album.label.labelGroup.name,
                        labelGroupCode: subject.album.label.labelGroup.code,
                        trackName: subject.track.name,
                        trackVersionNames: subject.track.version_names,
                        trackDuration: subject.track.duration,
                        fixationId: subject.fixationId,
                        albumName: subject.album.name,
                        albumCode: subject.album.code,
                        context: context
                    });
                });
            });

            $rootScope.$on(this.MIXPANEL_PLAYLIST_ADD, (event, data) => {
                mixpanel.track('Playlist Add', data);
            });

            $rootScope.$on(this.DISPLAY_SIMILAR_TRACKS, (event, type, subject) => {
                mixpanel.track('Display Similar Tracks', {
                    type: type,
                    labelName: subject.album.label.name,
                    labelCode: subject.album.label.code,
                    labelGroupName: subject.album.label.labelGroup.name,
                    labelGroupCode: subject.album.label.labelGroup.code,
                    trackName: subject.track.name,
                    trackVersionNames: subject.track.version_names,
                    trackDuration: subject.track.duration,
                    fixationId: subject.fixationId,
                    albumName: subject.album.name,
                    albumCode: subject.album.code
                });
            });

            $rootScope.$on(this.THEMED_PLAYLIST, (event, data) => {
                mixpanel.track('Themed Playlist', data);
            });

            $rootScope.$on(this.ALBUM_CLICK, (event, data) => {
                mixpanel.track('Album Click', data);
            });
        }
    };
}];


// WEBPACK FOOTER //
// ./src/PlayApp/AppBundle/Resources/js/angular/services/MixpanelEventsListener.js